import React from 'react';
import './modal.css';
export const Modal = (props: {closeModal: () => void}) => {
  const closeModal = props.closeModal;
  return (
    <React.Fragment>
      <div className="modal">
        <div className="modal__title">Извините, все слоты заполнены</div>
        <div className="modal__text">Удалите какую-нибудь игрушку, чтобы добавить другую в избранное</div>
        <button className="store__filters-button modal__button" onClick={closeModal}>Хорошо</button>
      </div>
      <div className="overlay"></div>
    </React.Fragment>
  )
};